/* Cart Cross-Sells v2 — event delegation for add-to-cart + variant switching */
/* Loaded once in theme.liquid; uses document-level delegation so it works
   regardless of when/how the mini-cart section HTML is injected. */
(function(){
  'use strict';

  /* Variant selector: update the card's active variant ID + price display */
  document.addEventListener('change', function(e) {
    var select = e.target;
    if (!select.matches || !select.matches('[data-variant-select]')) return;
    var card = select.closest('.cart-crosssell-card');
    if (!card) return;

    var selectedOption = select.options[select.selectedIndex];
    var newVid = select.value;
    var newPrice = selectedOption.getAttribute('data-price');

    /* Update the card's variant ID */
    card.dataset.variantId = newVid;

    /* Update the add button's variant ID */
    var addBtn = card.querySelector('.cart-crosssell-card__add');
    if (addBtn) addBtn.dataset.variantId = newVid;

    /* Update price display if data-price is set (value is in cents) */
    if (newPrice) {
      var priceEl = card.querySelector('.cart-crosssell-card__price-current');
      var discount = addBtn ? parseInt(addBtn.dataset.discount || '0') : 0;
      var priceCents = parseInt(newPrice);
      if (priceEl) {
        var finalCents = discount > 0 ? (priceCents - discount * 100) : priceCents;
        priceEl.textContent = '$' + (finalCents / 100).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
      }
      var origEl = card.querySelector('.cart-crosssell-card__price-original');
      if (origEl) origEl.textContent = '$' + (priceCents / 100).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    }
  });

  /* Add to cart button click */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.cart-crosssell-card__add');
    if (!btn) return;
    if (btn.classList.contains('loading') || btn.classList.contains('added')) return;

    e.preventDefault();
    e.stopPropagation();
    btn.classList.add('loading');

    var variantId = parseInt(btn.dataset.variantId);
    var discount = parseInt(btn.dataset.discount || '0');
    var card = btn.closest('.cart-crosssell-card');

    var payload = { items: [{ id: variantId, quantity: 1 }] };
    if (discount > 0) {
      payload.items[0].properties = {
        '_bundle_discount': discount,
        '_bundle_type': 'hyperice'
      };
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function(resp) {
      if (!resp.ok) throw new Error('Add failed');
      /* Success — swap to checkmark */
      btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
      btn.classList.remove('loading');
      btn.classList.add('added');
      if (card) card.classList.add('in-cart');

      /* Refresh the cart drawer via section rendering */
      return fetch('/?sections=mini-cart');
    })
    .then(function(resp) { return resp.json(); })
    .then(function(sections) {
      if (!sections['mini-cart']) return;
      var parser = new DOMParser();
      var doc = parser.parseFromString(sections['mini-cart'], 'text/html');

      /* Update cart items */
      var newItems = doc.querySelector('#main-cart-items');
      var curItems = document.querySelector('#main-cart-items');
      if (newItems && curItems) curItems.innerHTML = newItems.innerHTML;

      /* Update subtotal */
      var newSub = doc.querySelector('#mini-cart-subtotal');
      var curSub = document.querySelector('#mini-cart-subtotal');
      if (newSub && curSub) curSub.textContent = newSub.textContent;

      /* Update cart count bubble */
      var newBubble = doc.querySelector('.cart-count-bubble');
      var curBubble = document.querySelector('.cart-count-bubble');
      if (newBubble && curBubble) curBubble.innerHTML = newBubble.innerHTML;

      /* Update the cross-sells section (to reflect new in-cart states) */
      var newCrossSells = doc.querySelector('#cart-crosssells');
      var curCrossSells = document.querySelector('#cart-crosssells');
      if (newCrossSells && curCrossSells) curCrossSells.innerHTML = newCrossSells.innerHTML;
    })
    .catch(function(err) {
      console.error('[CartCrossSells] Error:', err);
      btn.classList.remove('loading');
    });
  });
})();
